import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2ba19716&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=2ba19716&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba19716",
  null
  
)

export default component.exports